import WtLogger from 'services/utils/wt-logger';

export const gaProviderLogger = WtLogger.register({
    name: 'gaProvider',
});
